export default __webpack_public_path__ + "static/media/zw.7fc9f782.svg";